import CommonNaviIconMenu from '../../common/component/NaviIconMenu'

class NaviIconMenu extends CommonNaviIconMenu {
  constructor (props) {
    super(props)
    this.userRole = 'companyUser'
    this.userRoleUrl = 'company_user'
    // 並び順・色は Backlog フィードバック(2026/08/17)に準拠。
    // マイページ/お知らせ(緑)/共有ファイル(橙)/見積書(青)/雛型(ピンク)/
    // マニュアル視聴(紫)/視聴申込(紫)/個人設定(黒)/(少し離して)アンケート回答(黒)
    this.naviIconSetting = [
      {
        title: 'マイページ',
        url: '/company_user/',
        iconClass: 'icon-home icon-large'
      },
      {
        title: 'お知らせ',
        url: '/company_user/information',
        iconClass: 'icon-info-sign icon-large',
        linkClass: 'kw-btn-success'
      },
      {
        title: '共有ﾌｧｲﾙ',
        url: '/company_user/shared_files',
        iconClass: 'icon-file icon-large',
        linkClass: 'kw-btn-warning'
      },
      {
        title: '見積書',
        url: '/company_user/estimation/real',
        iconClass: 'icon-list-alt icon-large',
        linkClass: 'kw-btn-info'
      },
      {
        title: '雛型',
        url: '/company_user/estimation/template',
        iconClass: 'icon-hdd icon-large',
        linkClass: 'kw-btn-inverse'
      },
      {
        title: 'ﾏﾆｭｱﾙ視聴',
        url: 'https://deliveru.jp/',
        iconClass: 'icon-facetime-video icon-large',
        external: true,
        linkClass: 'kw-btn-manual'
      },
      {
        title: '視聴申込',
        url: 'https://deliveru.jp/userregform/register/ufmX91Fr1M4m',
        iconClass: 'icon-edit icon-large',
        external: true,
        linkClass: 'kw-btn-manual'
      },
      {
        title: '個人設定',
        url: '/company_user/personal_setting_home',
        iconClass: 'icon-user icon-large',
        linkClass: 'kw-btn-black'
      },
      {
        title: 'ｱﾝｹｰﾄ回答',
        url: '/company_user/survey_answer',
        iconClass: 'icon-file icon-large',
        linkClass: 'kw-btn-black',
        // アンケートは少し離して配置する
        itemStyle: { marginLeft: '42px' }
      }
    ]
  }
}

export default NaviIconMenu



// WEBPACK FOOTER //
// ./src/company_user/components/NaviIconMenu.js